import classNames from 'classnames';
import React, { JSX } from 'react';

import '@eika/card-style/src/InfoCard.scss';

export type InfoCardTitleProps = JSX.IntrinsicElements['h1'];

const TitleH1 = ({ children, className, ...rest }: InfoCardTitleProps): JSX.Element => (
    <h1 className={classNames(className, 'typography-h1__light')} {...rest}>
        {children}
    </h1>
);
const TitleH2 = ({ children, className, ...rest }: InfoCardTitleProps): JSX.Element => (
    <h2 className={classNames(className, 'typography-h2')} {...rest}>
        {children}
    </h2>
);
const TitleH3 = ({ children, className, ...rest }: InfoCardTitleProps): JSX.Element => (
    <h3 className={classNames(className, 'typography-h3')} {...rest}>
        {children}
    </h3>
);

export interface InfoCardImageProps {
    src: string;
    alt: string;
}

const Image: React.FC<InfoCardImageProps> = ({ src, alt }) => {
    return <img src={src} alt={alt} />;
};

type DivElementProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;
export interface InfoProps extends DivElementProps {
    className?: string;
    skipBackground?: boolean;
    asHeader?: boolean;
    img?: JSX.Element;
}

interface InfoCardComposition {
    TitleH1: React.FC<InfoCardTitleProps>;
    TitleH2: React.FC<InfoCardTitleProps>;
    TitleH3: React.FC<InfoCardTitleProps>;
    Image: React.FC<InfoCardImageProps>;
}

const InfoCard: React.FC<InfoProps> & InfoCardComposition = ({
    className,
    skipBackground,
    children,
    asHeader = false,
    img,
    ...rest
}) => {
    return (
        <div
            className={classNames(
                className,
                'sgw-info-card',
                { 'show-background': !skipBackground },
                { 'as-header': asHeader },
            )}
            {...rest}
        >
            {img && <div className="sgw-info-card__img-wrapper">{img}</div>}
            {asHeader ? (
                <div className="sgw-info-card__content-wrapper typography-paragraph">{children}</div>
            ) : (
                children
            )}
        </div>
    );
};

InfoCard.TitleH1 = TitleH1;
InfoCard.TitleH2 = TitleH2;
InfoCard.TitleH3 = TitleH3;
InfoCard.Image = Image;

export default InfoCard;
